<template>
  <div class="calico-progress-bar">
    <div class="action-container">
      <div style="width: fit-content">
        <button
          v-if="steps[current - 1]"
          class="button-tertiary--small"
          @click="back"
        >
          <i class="bi bi-arrow-left" />
          Back: {{ steps[current - 1].name }}
        </button>
      </div>
    </div>
    <span
      v-if="steps[current]"
      class="heading--xsmall"
    >
      {{ steps[current].name }}
    </span>
    <div class="progresbar">
      <calico-progressbar-step
        v-for="(step, index) in progressSteps"
        :key="index"
        :line="index > 0"
        :active="index === (current - 1)"
        :complete="step.completed"
      />
    </div>
  </div>
</template>

<script lang="js">
import CalicoProgressbarStep from '@/components/calico/progressBarStep/index.vue'

export default {
  name: 'CalicoProgressBar',
  components: {
    CalicoProgressbarStep
  },
  props: {
    current: {
      type: Number,
      default: 0,
    },
    steps: {
      type: Array,
      default: () => [{ name: '', completed: false, timestamp: '' }]
    }
  },
  computed: {
    progressSteps() {      
      return this.steps.length <= 3 ? [] : this.steps.slice(1, this.steps.length - 1)
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
  }
}
</script>

<style lang="scss">
.calico-progress-bar {
  @include stack-space($space-medium);
  @include inset-space($space-medium);
  width: 100%;

  .action-container {
    @include inline-space($space-medium);
    align-items: center;

    label {
      color: $color-neutral;
    }
  }

  .progresbar {
    @include inline-space($space-none);
  }
}
</style>
